import { render, staticRenderFns } from "./WebLayout.vue?vue&type=template&id=6cd5bc45"
import script from "./WebLayout.vue?vue&type=script&lang=js"
export * from "./WebLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports